module.exports = __webpack_public_path__ + "static/img/icon-待办事项.a19717b4.png";